<script src="../../../vue.config.js"></script>
<template>
  <el-dialog :visible="showModal" width="80%" :show-close="false" :modal-append-to-body="false" @close="$emit('close')">
    <div class="header">
      <div class="header-title">
        {{ propsData.date }} 分布式光伏统计明细
      </div>
      <div @click="showModal = false;" class="header-close"><i class="el-icon-close"></i></div>
    </div>
    <div class="charge-data-detail">
      <div class="detail-title">站点明细</div>
      <div class="detail-table">
        <div class="table-main">
          <el-table
              :data="dataList.slice((currentPage - 1)*pageSize,currentPage*pageSize)"
              @sort-change="softCharge"
              border
              style="width: 100%">

            <el-table-column label="序号" width="150px" align="left">
              <template slot-scope="scope">
                {{ (scope.$index+1)+(currentPage-1)*pageSize }}
              </template>
            </el-table-column>

            <el-table-column
                prop="name"
                width="600px"
                label="光伏站名称"
                sortable
            />

            <el-table-column
                prop="kwh"
                label="发电量"
                sortable
            />
            <el-table-column
                prop="earnings"
                label="收益（元）"
                sortable
            />
          </el-table>

          <el-pagination
              @current-change="changePage"
              :current-page.sync="currentPage"
              :page-size="pageSize"
              layout="total, prev, pager, next, jumper"
              :total="dataList.length">
          </el-pagination>
        </div>
      </div>
    </div>
  </el-dialog>
</template>
<script>
import { Loading } from "element-ui";

export default {
  name: "Photovoltaic_Detail",
  data() {
    return {
      showModal: false,
      propsData: {},
      detailData: {},
      dataList: [],
      pageSize: 15,
      currentPage: 1,
      totalStatistics:[]
    };
  },
  methods: {
    softCharge(soft){
      let prop = soft.prop;
      let order = soft.order;
      //升序
      if(order === 'ascending'){
        this.dataList.sort((a, b) => a[prop] < b[prop] ? -1 : a[prop] > b[prop] ? 1 : 0);
      }
      //降序
      if(order === "descending"){
        this.dataList.sort((a, b) => a[prop] < b[prop] ? 1 : a[prop] > b[prop] ? -1 : 0) ;
      }
    },
    open(data) {
      this.propsData = data;
      const loading = Loading.service({
        lock: true,
        text: "正在加载..",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      console.log(this.propsData)
      Promise.allSettled([this.getData()]).then(() => {
        loading.close();
        this.showModal = true;
      });
    },
    changePage(page) {
      this.currentPage = page;
    },
    getData() {
      return new Promise(resolve => {
        this.$api.getDayStatistics({statisticsDate : this.propsData.date})
            .then(res => {
              this.dataList = res.data;
              resolve();
            });
      });
    },
  },
};
</script>
<style scoped lang="scss">
@import "../../style/_parameter.scss";

::v-deep.el-table .el-table__header-wrapper tr th {
  background-color: #0CC874;
}

::v-deep.el-table td, ::v-deep.el-table th {
  height: 90px;
  color: #fff;
  box-sizing: border-box;
  padding: 0 20px;
}
::v-deep .el-table__body{
  pointer-events: none !important;
}
::v-deep.el-table .cell {
  line-height: 40px;
}

::v-deep.el-table .caret-wrapper{
  transform: scale(2);
  margin-left: 10px;
}

.header {
  height: 50px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  margin-top: -30px;
  box-sizing: border-box;
  padding: 0 30px;

  .header-title {
    font-size: 34px;
    color: rgb(181, 228, 255);
    font-weight: bold;
    display: flex;
    align-items: center;
  }

  .header-video-btn {
    font-size: 30px;
    font-weight: bold;
    color: #fff;
    margin-left: 60px;
    width: 220px;
    height: 60px;
    display: flex;
    justify-content: center;
    align-items: center;
    border: solid 2px #fff;
    border-radius: 60px;
    cursor: pointer;

    i {
      font-size: 40px;
      margin-right: 10px;
    }

    &:hover {
      opacity: .8;
    }
  }


  .header-close {
    width: 60px;
    height: 60px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    background-color: $red;
    border-radius: 100%;

    i {
      font-size: 40px;
    }

    cursor: pointer;

    &:hover {
      opacity: .8;
    }
  }
}

.detail-title {
  font-size: 32px;
  font-weight: 500;
  margin-top: 30px;
  margin-bottom: 15px;
}

.charge-data-detail {
  height: auto;
  box-sizing: border-box;
  padding: 40px;

  .detail-wrap {
    height: 384px;
    border-top: solid 2px #ccc;
  }

  .detail-left {
    float: left;
    width: 500px;
    height: 100%;
    box-sizing: border-box;
    padding: 30px;
    border-left: solid 2px #ccc;
    border-right: solid 2px #ccc;
    border-bottom: solid 2px #ccc;

    .detail-title {
      text-align: center;
      font-size: 30px;
      font-weight: bold;
      color: #D1D2D3;
      margin-bottom: 40px;
    }

    .detail-icon {
      margin: 0 auto;
      width: 260px;
      height: 260px;

      img {
        width: 100%;
        height: 100%;
      }
    }

    .detail-status {
      font-size: 30px;
      margin-top: 32px;
      text-align: center;

      &.green {
        color: #63CA2D;
      }

      &.red {
        color: #E6474A;
      }

      &.gray {
        color: #8E8E8E;
      }

      &.purple {
        color: #6B51FF;
      }
    }
  }

  .detail-main {
    float: left;
    width: calc(100% - 500px);
    height: 100%;
    box-sizing: border-box;

    .detail-row {
      float: left;
      width: 40%;
      height: 96px;

      &.width100 {
        width: 100%;

        .row-title, .row-content {
          width: 50%;
        }
      }

      &:nth-of-type(2n) {
        width: 60%;
      }

      box-sizing: border-box;

      .row-title {
        float: left;
        width: 360px;
        height: 96px;
        line-height: 96px;
        border-right: solid 2px #ccc;
        border-bottom: solid 2px #ccc;
        box-sizing: border-box;
        background: rgba(255, 255, 255, .1);
        padding: 0 30px;
        color: #CDCECF;
        font-size: 28px;
      }

      .row-content {
        float: left;
        width: calc(100% - 360px);
        height: 96px;
        line-height: 96px;
        padding: 0 30px;
        box-sizing: border-box;
        border-right: solid 2px #ccc;
        border-bottom: solid 2px #ccc;
        color: #BEBEC2;
        font-size: 28px;
        @extend .omit;
      }
    }
  }
}

.detail-table {
  position: relative;
  height: calc(100% - 522px);
  margin-top: 20px;

  .table-filter {
    height: 96px;
    margin-top: 30px;

    .filter-item {
      float: left;
      @extend .clearfix;
      width: 250px;
      transform: scale(2);
      margin-left: 130px;

      .filter-title {
        float: left;
        width: 80px;
        line-height: 38px;
        color: #BEBEC1;
      }

      .filter-content {
        float: left;
        width: calc(100% - 80px);
      }
    }
  }

  .table-main {
    height: calc(100% - 116px);

    * {
      font-size: 28px !important;
    }

    .el-table tbody tr {
      pointer-events: none;
    }

    .el-table thead {
      color: #fff;

      th.el-table__cell {
        background: transparent;
      }
    }

    .el-table .el-table__cell {
      padding: 25px;
    }

    .el-table .caret-wrapper {
      width: 34px;
      height: 54px;
    }

    .el-table .sort-caret {
      border-width: 10px;

      &.ascending {
        top: 0;
      }

      &.descending {
        bottom: 2px;
      }
    }
  }
}

::v-deep.el-pagination {
  margin-top: 50px;
}

::v-deep.el-pagination * {
  font-size: 28px !important;
}
</style>
